<template>
<div>
  <el-row>
    <el-col :span="12" style="text-align: center;font-size: 18px;color: #1a1a1a">编辑前</el-col>
    <el-col :span="12" style="text-align: center;font-size: 18px;color: #1a1a1a">编辑后</el-col>
  </el-row>
  <div style="height: 1px;background-color: #ebebeb;margin: 15px 0"></div>
  <el-row style="font-size: 14px">
<!--  旧信息  -->
    <el-col :span="12" style="border-right: 1px solid #dedcdc">
      <div v-if="isHomePerson === 2">
      <el-col :span="12">
        <div class="left-name">
          <span>姓名：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.name">{{ oldMsg.person.name }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>性别：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.sex">{{getSex(oldMsg.person.sex)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>籍贯：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.nativeplace">{{ oldMsg.person.nativeplace }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>民族：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.nation">{{ oldMsg.person.nation }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>出生日期：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.birthday">{{ oldMsg.person.birthday }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>身份证号：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.idcard_num">{{ oldMsg.person.idcard_num }}</span>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="left-name">
          <span>身份证地址：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.idcard_address">{{ oldMsg.person.idcard_address }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>联系方式：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.phone">{{ oldMsg.person.phone }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>接听时间段：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.timelist">{{ oldMsg.person.timelist }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>血型：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.blood_type">{{getBloodTypeName(oldMsg.person.blood_type)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>健康状况：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.have_disease === ''">健康</span>
          <span v-else>患病</span>
          <el-button size="mini" v-if="oldMsg.person.have_disease !== ''" type="primary" plain @click="seeDisease(oldMsg.person.have_disease, oldMsg.person.input_disease)">查看</el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>服务频率：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.frequencyid">{{getFrequencyName(oldMsg.person.frequencyid)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>所属项目：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.projectid">{{getProjectName(oldMsg.person)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>特殊情况：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.circumstances">{{ oldMsg.person.circumstances }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>生命体征：</span>
        </div>
        <div class="right-show-name">
          <span v-if="oldMsg.person.is_dead === 0">在世</span>
          <span v-if="oldMsg.person.is_dead === 1">离世 {{oldMsg.person.dead_time}}</span>
        </div>
      </el-col>
      </div>
      <div v-if="isHomePerson === 1">
      <el-col :span="12">
        <div class="left-name">
          <span>所属区域：</span>
        </div>
        <div class="right-show-name all-three-point">
          <span v-if="oldMsg.home.orglevelname">{{ oldMsg.home.orglevelname }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>{{isLabel}}：</span>
        </div>
        <div class="right-show-name all-three-point">
          <span v-if="oldMsg.home.address">{{ oldMsg.home.address }}</span>
        </div>
      </el-col>
      </div>
    </el-col>
<!--  新信息  -->
    <el-col :span="12">
      <div v-if="isHomePerson === 2">
      <el-col :span="12">
        <div class="left-name">
          <span>姓名：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.name">{{ newMsg.person.name }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>性别：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.sex">{{getSex(newMsg.person.sex)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>籍贯：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.nativeplace">{{ newMsg.person.nativeplace }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>民族：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.nation">{{ newMsg.person.nation }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>出生日期：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.birthday">{{ newMsg.person.birthday }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>身份证号：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.idcard_num">{{ newMsg.person.idcard_num }}</span>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="left-name">
          <span>身份证地址：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.idcard_address">{{ newMsg.person.idcard_address }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>联系方式：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.phone">{{ newMsg.person.phone }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>接听时间段：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.timelist">{{ newMsg.person.timelist }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>血型：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.blood_type">{{getBloodTypeName(newMsg.person.blood_type)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>健康状况：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.have_disease === ''">健康</span>
          <span v-else>患病</span>
          <el-button size="mini" v-if="newMsg.person.have_disease !== ''" type="primary" plain @click="seeDisease(newMsg.person.have_disease, newMsg.person.input_disease)">查看</el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>服务频率：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.frequencyid">{{getFrequencyName(newMsg.person.frequencyid)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>所属项目：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.projectid">{{getProjectName(newMsg.person)}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>特殊情况：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.circumstances">{{ newMsg.person.circumstances }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>生命体征：</span>
        </div>
        <div class="right-show-name">
          <span v-if="newMsg.person.is_dead === 0">在世</span>
          <span v-if="newMsg.person.is_dead === 1">离世 {{newMsg.person.dead_time}}</span>
        </div>
      </el-col>
      </div>
      <div v-if="isHomePerson === 1">
      <el-col :span="12">
        <div class="left-name">
          <span>所属区域：</span>
        </div>
        <div class="right-show-name all-three-point">
          <span v-if="newMsg.home.orglevelname">{{ newMsg.home.orglevelname }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="left-name">
          <span>{{isLabel}}：</span>
        </div>
        <div class="right-show-name all-three-point">
          <span v-if="newMsg.home.address">{{ newMsg.home.address }}</span>
        </div>
      </el-col>
      </div>
    </el-col>
    <el-col :span="12" style="margin-top: 20px;border-top: 1px solid #ebebeb;padding-top: 5px">
      <div class="left-name">
        <span>备注：</span>
      </div>
      <div class="right-show-name">
        <el-input v-if="check_type === 0" style="width: 100%" type="textarea" :rows="2" placeholder="请输入审核备注" v-model="handleMessage"></el-input>
        <span v-else>{{checkObj.row.approve_remark}}</span>
      </div>
    </el-col>
    <el-col :span="12" style="margin-top: 20px;border-top: 1px solid #ebebeb;padding-top: 5px">
      <div class="left-name">
        <span style="color: red;font-size: 16px">* </span><span>审核状态：</span>
      </div>
      <div class="right-show-name">
        <el-select v-fixZoom v-if="check_type === 0" v-model="status" filterable placeholder="请选择" style="width: 80%">
          <el-option v-for="item in statusArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <span v-else>
          <span v-if="checkObj.row.check_type === 1">已通过</span>
          <span v-if="checkObj.row.check_type === 2">已拒绝</span>
        </span>
      </div>
    </el-col>
  </el-row>
  <div>
  </div>
  <div style="float: right;margin-top: 20px;margin-right: 20px;height: 50px" v-if="check_type === 0">
    <div class="send-btn" @click="checkEndCommit()"><span>审 核</span></div>
  </div>
  <div style="clear: both;"></div>
  <el-dialog width="600px" :visible.sync="diseaseShow" v-if="diseaseShow" :close-on-click-modal="false" center append-to-body class="all-open">
    <disease-select v-model="diseaseShow" :diseaseObj="diseaseObj"></disease-select>
  </el-dialog>
</div>
</template>

<script>
import {approvecheckinfo} from '../../../api/alarmservice'
// import {querydiseasename} from '../../../api/home'
import diseaseSelect from '../../handlealarm/childComponents/diseaseSelect'

export default {
  name: 'checkMsg',
  components: {diseaseSelect},
  model: {
    prop: 'checkShow',
    event: 'change'
  },
  props: {
    checkObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isLabel: '',
      oldMsg: {
        home: '',
        person: {
          is_dead: 0
        }
      },
      newMsg: {
        home: '',
        person: {
          is_dead: 0
        }
      },
      bloodTypes: [
        {name: 'A型', value: 1},
        {name: 'B型', value: 2},
        {name: 'AB型', value: 3},
        {name: 'O型', value: 4},
        {name: 'A-型', value: 5},
        {name: 'B-型', value: 6},
        {name: 'AB-型', value: 7},
        {name: 'O-型', value: 8}
      ],
      projects: [],
      frequencys: [],
      handleMessage: '',
      status: '',
      statusArr: [{name: '通过', id: 1}, {name: '拒绝', id: 2}],
      check_type: '',
      diseasesnew: [],
      diseaseShow: false,
      selectdiseasesids: [],
      isHomePerson: 0, // 0 其他 1 家 2 人
      diseasenames: [],
      diseaseObj: {
        isEditMsg: false,
        isCallBack: false,
        diseasenames: [],
        diseasesnew: [],
        selectdiseasesids: [],
        diseaseids: [],
        input_disease: ''
      }
    }
  },
  created () {
    this.getDisease()
    this.moduletag = this.$store.state.user.moduletag
    if (this.moduletag === 1) {
      this.isLabel = '所属家庭'
    } else if (this.moduletag === 2) {
      this.isLabel = '所属房间'
    } else {
      this.isLabel = '家庭/房间'
    }
    this.getStartData()
  },
  methods: {
    seeDisease (disease, inpt) {
      // console.log(disease)
      let arr = disease.split(',')
      this.selectdiseasesids = []
      for (let i = 0; i < arr.length; i++) {
        this.selectdiseasesids.push(parseInt(arr[i]))
      }
      // console.log(arr)
      this.diseaseObj.diseaseids = this.selectdiseasesids
      this.diseaseObj.input_disease = inpt
      this.diseaseShow = true
    },
    // 患病类型
    getDisease () {
      this.diseasenames = this.checkObj.diseasenames
      this.diseasesnew = this.commonType.getDisease(this.diseasenames)

      this.diseaseObj.diseasenames = this.checkObj.diseasenames
      this.diseaseObj.diseasesnew = this.commonType.getDisease(this.diseasenames)
    },
    getStartData () {
      // let msg = message.toString()
      // let msgJSON = JSON.parse(msg)
      this.projects = this.checkObj.projects
      this.frequencys = this.checkObj.frequencys
      let changeinfo = JSON.parse(this.checkObj.row.changeinfo.toString())
      if (changeinfo.homeinfo !== '') {
        this.isHomePerson = 1
      }
      if (changeinfo.personinfo !== '') {
        this.isHomePerson = 2
      }
      if (changeinfo.homeinfo !== '' && changeinfo.personinfo !== '') {
        this.isHomePerson = 0
      }
      // console.log(changeinfo)
      this.oldMsg = {
        home: this.checkObj.row.home,
        person: this.checkObj.row.person
      }
      this.newMsg = {
        home: changeinfo.homeinfo,
        person: changeinfo.personinfo
      }
      console.log(this.oldMsg.person, this.newMsg.person)
      this.check_type = this.checkObj.row.check_type
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getBloodTypeName (val) {
      let name = val
      for (let i = 0; i < this.bloodTypes.length; i++) {
        if (val === this.bloodTypes[i].value) {
          name = this.bloodTypes[i].name
        }
      }
      return name
    },
    getProjectName (row) {
      let projectname = ''
      if (row.projectids && row.projectids !== '' && row.projectids.length > 0) {
        for (let i = 0; i < row.projectids.length; i++) {
          if (projectname === '') {
            projectname = this.getProject2(row.projectids[i])
          } else {
            projectname = projectname + ',' + this.getProject2(row.projectids[i])
          }
        }
      } else {
        projectname = row.projectid
        for (let i = 0; i < this.projects.length; i++) {
          if (row.projectid === this.projects[i].id) {
            projectname = this.projects[i].projectname
          }
        }
      }
      return projectname
    },
    getProject2 (id) {
      let projectname = id
      for (let i = 0; i < this.projects.length; i++) {
        if (id === this.projects[i].id) {
          projectname = this.projects[i].projectname
        }
      }
      return projectname
    },
    // getProjectName (id) {
    //   let name = id
    //   for (let i = 0; i < this.projects.length; i++) {
    //     if (id === this.projects[i].id) {
    //       name = this.projects[i].projectname
    //     }
    //   }
    //   return name
    // },
    getFrequencyName (id) {
      let name = id
      for (let i = 0; i < this.frequencys.length; i++) {
        if (id === this.frequencys[i].id) {
          name = this.frequencys[i].frequency
        }
      }
      return name
    },
    getHeath (disease) {
      if (disease === '') {
        return '健康'
      } else {
        return '患病'
      }
    },
    checkEndCommit () {
      if (this.status === '') {
        this.$message({
          message: '请选择审核状态。',
          type: 'warning'
        })
        return
      }
      let data = {
        id: this.checkObj.row.id,
        check_type: parseInt(this.status),
        remark: this.handleMessage
      }
      approvecheckinfo(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功审核信息',
          type: 'success',
          duration: 2000
        })
        this.$emit('changeCheck')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.right-show-name{
  text-align: left;
  height: 35px;
  line-height: 35px;
  width: calc(100% - 101px);
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/checkMsg.vue